import { Css, ScrollableParent } from "@homebound/beam";
import { Outlet } from "react-router-dom";

/**
 * Scrollable content frame under `GlobalNavLayout` (no SideNav).
 *
 * Role: data router pathless layout. Used for legacy library/trade-partner pages still on
 * `GlobalNavLayout`, and for project full-page flows that skip `ProjectLegacySideNavLayout`.
 * New pages that use Beam layouts (`PageHeaderLayout`, `GridTableLayout`, etc.) should nest
 * under `BeamNavbarLayout` only — see `src/routing/README.md` "Layout stacks".
 */
export function ScrollableParentLayout() {
  return (
    <ScrollableParent px={3} xss={Css.fg1.$}>
      <Outlet />
    </ScrollableParent>
  );
}
